import Vue from 'vue'
import printjs from "print-js"
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = (e) => {
      // 关键：把 .el-dialog 从 position: relative（margin 居中）转成 position: absolute，
      // 这样 left/top 就是相对于 fixed wrapper（视口）的绝对坐标，坐标系统一，
      // 否则 relative 的 left/top 只是相对于自身 normal flow 的偏移，无法真正贴边
      if (getComputedStyle(dragDom).position !== 'absolute') {
        const r = dragDom.getBoundingClientRect()
        dragDom.style.position = 'absolute'
        dragDom.style.margin = '0'
        dragDom.style.left = r.left + 'px'
        dragDom.style.top = r.top + 'px'
      }

      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }
      // 对于从未被拖过的弹窗，getComputedStyle 的 left/top 可能返回 "auto" 解析为 NaN，
      // 此时需用 getBoundingClientRect 作为实际位置的 fallback
      const rect = dragDom.getBoundingClientRect()
      if (isNaN(styL)) styL = rect.left
      if (isNaN(styT)) styT = rect.top
      // 弹窗自身的 margin-top 会带来视觉偏移，限制上边时需要抵消
      const marginTop = +sty.marginTop.replace(/px/g, '') || 0

      // 缓存尺寸，用于边界限制，确保标题栏不会完全移出屏幕
      const dialogWidth = rect.width || dragDom.clientWidth
      const headerHeight = dialogHeaderEl.offsetHeight
      const screenW = document.documentElement.clientWidth || window.innerWidth
      const screenH = document.documentElement.clientHeight || window.innerHeight
      const MIN_VISIBLE = 50 // 标题栏至少露出的像素数

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 水平边界：保证标题栏至少露出 MIN_VISIBLE 像素
        const rawLeft = l + styL
        const newLeft = Math.min(Math.max(rawLeft, -(dialogWidth - MIN_VISIBLE)), screenW - MIN_VISIBLE)
        // // 水平边界：弹窗不能被拖出屏幕左右两边，贴边就停
        // const rawLeft = l + styL
        // const newLeft = Math.min(Math.max(rawLeft, 0), screenW - dialogWidth)
        

        // 垂直边界：保证标题栏至少露出 MIN_VISIBLE 像素
        const rawTop = t + styT
        const minTop = -(headerHeight - MIN_VISIBLE) - marginTop
        const maxTop = screenH - headerHeight - MIN_VISIBLE
        const newTop = Math.min(Math.max(rawTop, minTop), maxTop)

        // 移动当前元素
        dragDom.style.left = `${newLeft}px`
        dragDom.style.top = `${newTop}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    const header = dragDom.querySelector('.el-dialog__header')
    header.style.position = 'relative'
    let fa = document.createElement('div')
    fa.style.border = '3px solid #fff'
    fa.style.width = '10px'
    fa.style.height = '10px'
    fa.setAttribute('class', 'fullscreenIcon')
    header.appendChild(fa)
    const fullscreen = dragDom.querySelector('.fullscreenIcon')
    let isFullScreen = false
    let nowHight = 0
    let nowWidth = 0
    let nowMarginTop = 0
    fullscreen.onclick = () => {
      if (isFullScreen == false) {
        nowHight = dragDom.clientHeight;
        nowWidth = dragDom.clientWidth;
        nowMarginTop = dragDom.style.marginTop;
        dragDom.style.left = 0;
        dragDom.style.top = 0;
        dragDom.style.height = "100%";
        dragDom.style.width = "100%";
        dragDom.style.maxHeight = "100%";
        dragDom.style.maxWidth = "100%";
        dragDom.style.setProperty('margin', 0, 'important')
        isFullScreen = true;
        header.style.cursor = 'initial';
      } else {
        // 恢复到 margin 居中的相对定位，清除绝对定位遗留的 left/top
        dragDom.style.position = 'relative'
        dragDom.style.left = ''
        dragDom.style.top = ''
        dragDom.style.margin = '4vh auto'
        dragDom.style.height = "auto";
        dragDom.style.width = nowWidth + 'px';
        dragDom.style.maxHeight = "calc(100% - 90px)";
        dragDom.style.maxWidth = "calc(100% - 30px)";
        isFullScreen = false;
        header.style.cursor = 'move';
      }
    }
    //双击头部效果
    dialogHeaderEl.ondblclick = (e) => {
      if (isFullScreen == false) {
        nowHight = dragDom.clientHeight;
        nowWidth = dragDom.clientWidth;
        nowMarginTop = dragDom.style.marginTop;
        dragDom.style.left = 0;
        dragDom.style.top = 0;
        dragDom.style.height = "100%";
        dragDom.style.width = "100%";
        dragDom.style.maxHeight = "100%";
        dragDom.style.maxWidth = "100%";
        dragDom.style.setProperty('margin', 0, 'important')
        isFullScreen = true;
        dialogHeaderEl.style.cursor = 'initial';
      } else {
        // 恢复到 margin 居中的相对定位，清除绝对定位遗留的 left/top
        dragDom.style.position = 'relative'
        dragDom.style.left = ''
        dragDom.style.top = ''
        dragDom.style.margin = '4vh auto'
        dragDom.style.height = "auto";
        dragDom.style.width = nowWidth + 'px';
        dragDom.style.maxHeight = "calc(100% - 90px)";
        dragDom.style.maxWidth = "calc(100% - 30px)";
        isFullScreen = false;
        dialogHeaderEl.style.cursor = 'move';
      }
    }
  }
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = binding.value.$el.querySelector('.el-dialog')

    el.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft

      document.onmousemove = function (e) {
        e.preventDefault() // 移动时禁用默认事件

        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        dragDom.style.width = `${l}px`
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

Vue.directive("expire", {
  componentUpdated(el, binding, vnode) {
    let d = new Date();
    let expire = new Date(binding.value);
    let input = el.querySelector("input")
    if (d > expire) {
      input.style.backgroundColor = "rgb(240, 169, 169)"
      return;
    } else if (
      expire.getTime() - d.getTime() <=
      6 * 30 * 24 * 3600 * 1000
    ) {
      input.style.backgroundColor = "rgb(245, 245, 153)"
    } else {
      input.style.backgroundColor = ""
    }
  }
})
Vue.directive("print",{
  bind(el,binding,vnode){
    el.onclick= function(e){
      el.id = "print"
      printjs({
        printable: "print",
        type: "html",
        style: binding?binding:"max-width: 210mm;max-height: 297mm"
      })
      el.id = null
    }
  }
})
